import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconBox, IconStructureNavArrow } from '../../../styles/Icons';
import { LegInfo, UserProfile } from '../common/desktop';
import { directGoBack } from '../myTeamBackOffice.actions';
import { LevelZeroTopInfo, LevelZeroWrap } from '../MyTeamBackofficeStyled';
import { getLegStregthsL } from '../utils';
import { DirectRootTeamMemberInfo } from './DirectRootTeamMemberInfo';

const DirectRootTeamMemberDesktop = () => {
  const { t } = useTranslation('myTeam');

  const dispatch = useDispatch();
  const { directBreadcrumbs, directTeamMemberInfo, rootTeamMember } =
    useSelector((state) => state.myTeamBackoffice);

  const BackUser = () => {
    return (
      <>
        {directBreadcrumbs?.length > 0 && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              dispatch(directGoBack());
            }}>
            {/* <StructureArrow style={{ transform: ' rotate(270deg)' }}>
              <img src={arrow} alt='back' />
            </StructureArrow> */}

            <IconBox style={{ transform: 'rotate(270deg)' }}>
              <Icon color={color.colors.neutral900}>
                <IconStructureNavArrow />
              </Icon>
            </IconBox>
          </div>
        )}
      </>
    );
  };
  const [leftLegStrenght, rightLegStrength] = getLegStregthsL(rootTeamMember);

  return (
    <div>
      <LevelZeroTopInfo>
        <DirectRootTeamMemberInfo />
      </LevelZeroTopInfo>
      <LevelZeroWrap>
        <div
          style={{
            width: '60px',
            position: 'absolute',
            left: -40,
            top: 'calc(50% - 30px)'
          }}>
          <BackUser />
        </div>
        <LegInfo
          legName={
            <>
              {t('left_team')} {leftLegStrenght}
            </>
          }
          legInfo={directTeamMemberInfo?.leftLegInfo}
        />
        <UserProfile
          teamMember={directTeamMemberInfo}
          teamMemberInfo={directTeamMemberInfo}
          directTeamMemberInfo={directTeamMemberInfo}
        />
        <LegInfo
          legName={
            <>
              {t('right_team')} {rightLegStrength}
            </>
          }
          legInfo={directTeamMemberInfo?.rightLegInfo}
        />
      </LevelZeroWrap>
    </div>
  );
};

export default DirectRootTeamMemberDesktop;
